import API from "./API";

const ProjectResponseService = {
  async getAllProjectsWithStatus() {
    const response = await API().get("Project/GetAllProjectListWithStatus", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getProjectsWithStatusForUserId(userId: number, roleId: number) {
    const response = await API().get(
      "Project/GetProjectListWithStatusForUserId/" + userId + "/" + roleId,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
};

export default ProjectResponseService;
